export default __webpack_public_path__ + "static/media/team103.301b8197.JPG";